import { Box, Button, Grid, IconButton, Typography } from '@mui/material';
import imageBackground from 'assets/images/backgrounds/bg-start-survey.jpeg';
import CloseIcon from '@mui/icons-material/Close';
import BrandLogo from 'common/components/brand-logo';
import React, { useEffect, useState } from 'react';
import { createStyleSheet } from 'utils/helpers';
import ModalShareSurvey from '../components/modal-share-survey';
import ViewMode from '../components/view-mode';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import ModalConfirm from 'common/components/modal-confirm';
import { closeSurvey } from 'utils/preview_helpers';
import { useAppSelector, useAppDispatch } from 'common/hook';
import {
    resetCaptureTimeStamp,
    resetCaptureTimeByQuestion,
} from 'slices/previewSurveySlice';
import {
    selectSurveyImage,
    selectWelcomeTextColor,
} from 'common/theme-selectors';

interface IStartSurveyProps {
    setSurveyStep: (step: number) => void;
}
const EndSurvey: React.FC<IStartSurveyProps> = () =>
    // {
    //     setSurveyStep
    // }
    {
        const [openModalShareSurvey, setOpenModalShareSurvey] = useState(false);
        const [openModalCampaignStatus, setOpenModalCampaignStatus] =
            React.useState(false);
        const me = useAppSelector((state) => state.previewSurvey.me);
        const surveyState = useAppSelector(
            (state) => state.previewSurvey.surveyState
        );
        const surveyImage = useAppSelector(selectSurveyImage);
        const welcomeTextColor = useAppSelector(selectWelcomeTextColor);
        const dispatch = useAppDispatch();

        useEffect(() => {
            dispatch(resetCaptureTimeByQuestion());
            dispatch(resetCaptureTimeStamp());
        }, [dispatch]);

        return (
            <Box
                sx={{
                    ...styles.startSurveyLayout,
                    backgroundImage: `url(${surveyImage ?? imageBackground})`,
                }}
            >
                <Grid
                    container
                    spacing={2}
                    sx={{
                        marginBottom: ['3rem', '4rem', '6rem', '8rem'],
                        alignItems: ['flex-end'],
                    }}
                >
                    <Grid item xs={12} md={4} sm={6}>
                        <BrandLogo />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={8}
                        sx={{
                            display: ['none', 'flex', 'flex', 'flex'],
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            gap: 2,
                        }}
                    >
                        <ViewMode />
                        {surveyState.answerable && (
                            <Button
                                onClick={() => setOpenModalShareSurvey(true)}
                                variant="contained"
                                sx={styles.btnShare}
                                startIcon={
                                    <ShareOutlinedIcon
                                        sx={{
                                            width: [22, 22, 22, 28, 28],
                                            height: [22, 22, 22, 28, 28],
                                        }}
                                    />
                                }
                            >
                                Chia sẻ
                            </Button>
                        )}

                        {me.creator && (
                            <IconButton
                                onClick={() =>
                                    closeSurvey(Number(surveyState.id), me)
                                }
                                className="close-surveys"
                            >
                                <CloseIcon
                                    sx={{
                                        color: (theme) =>
                                            theme.palette.common.white,
                                        width: [
                                            '2.5rem',
                                            '2rem',
                                            '2rem',
                                            '3rem',
                                            '3rem',
                                        ],
                                        height: [
                                            '2.5rem',
                                            '2rem',
                                            '2rem',
                                            '3rem',
                                            '3rem',
                                        ],
                                    }}
                                />
                            </IconButton>
                        )}
                    </Grid>
                </Grid>

                <Grid
                    container
                    spacing={2}
                    sx={{
                        marginBottom: ['3rem'],
                    }}
                >
                    <Grid item xs={12} md={7} lg={5} xl={5}>
                        <Typography
                            variant="h4"
                            align="left"
                            sx={{
                                fontSize: [
                                    '2rem',
                                    '2rem',
                                    '3rem',
                                    '3.5rem',
                                    '3.5rem',
                                ],
                                fontWeight: '900',
                                lineHeight: [
                                    '2.5rem',
                                    '2.5rem',
                                    '3.5rem',
                                    '4rem',
                                    '4rem',
                                ],
                                color: welcomeTextColor,
                                marginBottom: [
                                    '1rem',
                                    '1rem',
                                    '1rem',
                                    '2rem',
                                    '2rem',
                                ],
                            }}
                        >
                            {surveyState.title}
                        </Typography>
                        <Typography
                            variant="h5"
                            align="left"
                            sx={{
                                fontSize: [
                                    '1.5rem',
                                    '1.5rem',
                                    '2rem',
                                    '2.2rem',
                                    '2.2rem',
                                ],
                                fontWeight: '700',
                                lineHeight: [
                                    '2rem',
                                    '2rem',
                                    '2.5rem',
                                    '3rem',
                                    '3rem',
                                ],
                                color: welcomeTextColor,
                                marginBottom: [
                                    '1rem',
                                    '1rem',
                                    '1.5rem',
                                    '1.5rem',
                                ],
                            }}
                        >
                            Cảm ơn bạn đã hoàn thành khảo sát
                        </Typography>
                    </Grid>
                </Grid>
                {openModalShareSurvey && (
                    <ModalShareSurvey
                        open={openModalShareSurvey}
                        onClose={() => setOpenModalShareSurvey(false)}
                    />
                )}
                {openModalCampaignStatus && (
                    <ModalConfirm
                        open={true}
                        onClose={() => setOpenModalCampaignStatus(false)}
                        title="Thông báo"
                        content={
                            <Box
                                sx={{
                                    fontSize: '24px',
                                }}
                            >
                                Chiến dịch khảo sát
                                <b> {`"${surveyState.title}"`}</b> đã kết thúc.
                                <br />
                                Vui lòng kiểm tra lại sau hoặc tham các chiến
                                dịch khác
                            </Box>
                        }
                    />
                )}
            </Box>
        );
    };
const styles = createStyleSheet({
    startSurveyLayout: {
        width: '100vw',
        minHeight: '100vh',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        padding: ['2rem', '2rem', '4rem', '4rem'],
    },
    btnStartSurvey: {
        padding: [
            '1rem 3rem',
            '1rem 3rem',
            '1.2rem 3.2rem',
            '1.5rem 3.5rem',
            '1.5rem 1.5rem',
        ],
        minWidth: ['10rem', '10rem', '15rem', '15rem'],
        height: ['2.5rem', '2.7rem', '3rem', '4rem', '4rem'],
        borderRadius: '50px',
        fontSize: ['1rem', '1rem', '1.2rem', '1.5rem', '1.5rem'],
        fontWeight: '700',
        lineHeight: ['1.5rem', '1.5rem', '2rem'],
    },
    btnShare: {
        minWidth: ['5rem', '7rem', '10rem', '12rem', '13rem'],
        height: ['2.5rem', '2rem', '2rem', '3rem', '3rem'],
        textTransform: 'none',
        borderRadius: '40px',
        fontSize: ['0.6rem', '0.7rem', '0.7rem', '1rem', '1rem'],
        fontWeight: '700',
        padding: ['1rem', '1rem', '1rem', '1.5rem 3rem'],
    },
});
export default EndSurvey;
